export const typeOfRegisterConfirmationEmailSentDialog = 'typeOfRegisterConfirmationEmailSentDialog';
export const typeOfRegisterConfirmationSuccessDialog = 'typeOfRegisterConfirmationSuccessDialog';
